import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CommonService } from 'wire-frame';


@Injectable({
  providedIn: 'root'
})
export class PreConsultationService {

  constructor(private http: HttpClient, private common: CommonService) { }

  getpreconsultation(payload: (string | null) = null) {
    return this.http.get(
      this.common.getBaseUrl() + 'preconsultation.php?action=preconsultationList' + (payload ? '&list=all' : '')
    );
  }

  addpreconsultation(payload: any) {
    // return this.http.post('/api/destinations', destination);
    payload["action"] = "addpreconsultation";
    return this.http.post(this.common.getBaseUrl() + 'preconsultation.php', payload);
  }

  updatepreconsultation(payload: any) {
    payload["action"] = "updatepreconsultation";
    return this.http.put(this.common.getBaseUrl() + 'preconsultation.php', payload);
  }

  deletepreconsultation(payload: any) {
    payload["action"] = "deletepreconsultation";
    return this.http.put(this.common.getBaseUrl() + 'preconsultation.php', payload);
  }
}
